<template>
  <div
    class="menu-side bg--blue-dark tx--bege"
    id="menu"
    style="display: block !important; z-index: 100 !important;"
  >
    <div class="hold-menu">
      <div class="mobile_only popup_close close-animate">
        <a href="javascript:void(0)" @click="TOGGLE_MENU"><CloseSvg /></a>
      </div>
      <div class="mm-user">
        <div class="user_row">
          שלום {{ activeUser.name }}.
          <a href="javascript:void(0)" @click="logout()">התנתקות</a>
        </div>
        <router-link to="/messages" class="mm-my-msg">
          <div class="relative">
            <span
              v-show="
                activeUser &&
                  activeUser.doctor_messages &&
                  activeUser.doctor_messages.length
              "
              class="pathology-dot"
            ></span>
            <img src="/assets/img/svg/sm-mail.svg" />
          </div>
          <div>יש לך <span class="underline">הודעות</span></div>
        </router-link>
      </div>

      <div class="calander_select_doc">
        <select2 v-model="selectedDoctor" name="doctorSelect">
          <option value="">בחר רופא</option>
          <option
            :value="doctor.id"
            v-for="(doctor, index) in doctors"
            :key="index"
          >
            {{ doctor.name }}
          </option>
        </select2>
      </div>
      <nav class="menu">
        <MenuItems
          :items="menuListMobile"
          :close-on-navigate="true"
          bell-class="pathology-bell-mobile"
          dot-class="pathology-dot-mobile"
          drop-open-class="bg--bege"
        />
      </nav>
      <a href="tel:0747049400" class="phone-text flex flex--start">
        <img src="/assets/img/svg/ic-phone-white.svg" alt="" />
        <span>מוקד תמיכה:</span>
        <a>09-9592974</a>
      </a>
      <div class="logo" @click="onLogo">
        <LogoSvg />
      </div>
      <div class="head--pad">
        <div class="no_mobile head_search relative">
          <input
            class="head_search_input"
            type="text"
            placeholder="חיפוש לפי ת.ז"
            v-on:keypress="numbersOnly"
          />
          <input class="head_search_submit" type="submit" value="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuMixin from "../../mixins/menuMixin.js";
import LogoSvg from "../../assets/img/svg/logo.svg";
import CloseSvg from "../../assets/img/svg/close.svg";
import MenuItems from "./MenuItems.vue";
import { mapActions } from "vuex";
import { menuListMobile } from "../../utilities/globals.js";

export default {
  name: "Menu",
  mixins: [menuMixin],
  components: { LogoSvg, CloseSvg, MenuItems },
  data() {
    return {
      selectedDoctor: this.$store.state.activeDoctor.id,
      menuListMobile
    };
  },
  methods: {
    ...mapActions(["TOGGLE_MENU", "CLOSE_MENU"]),
    numbersOnly(ev) {
      ev = ev ? ev : window.event;
      var charCode = ev.which ? ev.which : ev.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        ev.preventDefault();
      } else {
        return true;
      }
    },
    onLogo() {
      if (this.$route.path === "/dashboard") this.CLOSE_MENU();
      else this.$router.push("/dashboard");
    }
  },
  watch: {
    selectedDoctor(value) {
      this.$store.dispatch("SET_DOCTOR", value);
      this.$API.getRoomsByDoctor(this.activeDoctor.id).then(res => {
        if (res.data.data) {
          this.SET_DOCTOR_ROOMS(res.data.data);
        }
      });
    },
    $route(to, from) {
      this.CLOSE_MENU();
    }
  }
};
</script>
